import { useMemo } from 'react';
import { MAX_BALLS_BY_MARKET } from '../constants';
import {
  getNormalCountFromMarketType,
  getBonusCountFromMarketType,
  calculateCombinations,
} from '../utils/marketTypeHelpers';

export const useBallCounts = ({
  hasBalls,
  marketType,
  balls,
  mainGridTotal,
  editedNumbers,
}) => {
  const minNormalCount = useMemo(() => {
    if (!hasBalls) return 0;
    const parsed = getNormalCountFromMarketType(marketType);
    if (parsed != null) return parsed;
    return balls?.filter((n) => n.type === 'NORMAL').length ?? 0;
  }, [hasBalls, marketType, balls]);

  const maxNormalCount = useMemo(() => {
    if (!hasBalls || minNormalCount <= 0) return 0;
    const configMax = MAX_BALLS_BY_MARKET[minNormalCount] ?? minNormalCount;
    return Math.min(mainGridTotal, configMax);
  }, [hasBalls, minNormalCount, mainGridTotal]);

  const requiredBonusCount = useMemo(() => {
    if (!hasBalls) return 0;
    const parsed = getBonusCountFromMarketType(marketType);
    if (parsed != null) return parsed;
    return balls?.filter((n) => n.type === 'BONUS').length ?? 0;
  }, [hasBalls, marketType, balls]);

  const singleBetsCount = useMemo(() => {
    if (!hasBalls || minNormalCount <= 0) return 1;
    const normalCount = editedNumbers.filter((n) => n.type === 'NORMAL').length;
    if (normalCount < minNormalCount) return 1;
    return calculateCombinations(normalCount, minNormalCount);
  }, [hasBalls, editedNumbers, minNormalCount]);

  return {
    minNormalCount,
    maxNormalCount,
    requiredBonusCount,
    singleBetsCount,
  };
};
